import './settings.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Dropdown, Button, Form, Modal } from 'react-bootstrap';
import rmList from '../../mocks/profiles/rmList.json';
import smList from '../../mocks/profiles/smList.json';
import clientList from '../../mocks/profiles/clientList.json';
import editicon from '../../images/svg/editicon.svg';
import deleteicon from '../../images/svg/deleteicon.svg';
import newimageicon from '../../images/svg/newimageicon.svg';
import axios from 'axios';



function Settings() {
  const [selectedRM, setSelectedRM] = useState(localStorage.getItem('RM') || '');
  const [selectedSM, setSelectedSM] = useState(localStorage.getItem('SM') || '');
  const [selectedCust, setSelectedCust] = useState(localStorage.getItem('customer') || '');
  const [selectedLocalDuration, setLocalDuration] = useState(localStorage.getItem('duration') || '');
  const [rmNameList, setRMNameList] = useState([]);
  const [smNameList, setSMNameList] = useState([]);
  const [custNameList, setCustNameList] = useState([]);
  const [rmImage, setRmImage] = useState(null);
  const [smImage, setSmImage] = useState(null);
  const [custImage, setCustImage] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState({ minutes: '', seconds: '' });
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [transcript, setTranscript] = useState(localStorage.getItem('transcript'));
  const [Name, setName] = useState('');
  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [editingProfile, setEditingProfile] = useState(null);
  const [currentProfileImage, setCurrentProfileImage] = useState(null); // State to hold current profile image

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setSelectedRole('');
    setSelectedFile(null);
    setName('');
    setEditingProfile(null);
    setCurrentProfileImage(null);
    setSelectedDuration({ minutes: '', seconds: '' });
  };
  

  const handleSelect = (role) => {
    setSelectedRole(role);
  };

  useEffect(() => {
    return () => {
      setSelectedRole('');
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('RM', selectedRM);
  }, [selectedRM]);

  useEffect(() => {
    localStorage.setItem('SM', selectedSM);
  }, [selectedSM]);

  useEffect(() => {
    localStorage.setItem('customer', selectedCust);
  }, [selectedCust]);

  useEffect(() => {
    localStorage.setItem('duration', selectedLocalDuration);
  }, [selectedCust, selectedLocalDuration]);

  useEffect(() => {
    setRMNameList(rmList.profile);
  }, []);

  useEffect(() => {
    setSMNameList(smList.profile);
  }, []);

  useEffect(() => {
    setCustNameList(clientList.profile);
  }, []);

  useEffect(() => {
    const selectedRmItem = rmNameList.find(item => item.name === selectedRM);
    if (selectedRmItem) {
      setRmImage(selectedRmItem.image);
    } else {
      setRmImage(null);
    }
  }, [selectedRM, rmNameList]);

  useEffect(() => {
    const selectedSmItem = smNameList.find(item => item.name === selectedSM);
    if (selectedSmItem) {
      setSmImage(selectedSmItem.image);
    } else {
      setSmImage(null);
    }
  }, [selectedSM, smNameList]);

  useEffect(() => {
    const selectedCustItem = custNameList.find(item => item.name === selectedCust);
    if (selectedCustItem) {
      setCustImage(selectedCustItem.image);
    } else {
      setCustImage(null);
    }
  }, [selectedCust, custNameList]);
  useEffect(() => { //parse duration when setting customer list
    const parsedCustNameList = clientList.profile.map((item) => ({
      ...item,
      ...parseDuration(item.duration),
    }));
    setCustNameList(parsedCustNameList);
  }, []);

  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedFile(file);
    } else {
      alert('Please select an image file.');
    }
  };

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFormSubmit = async () => {
    // Check if Name and selectedRole are not empty
    if (Name && selectedRole) {
      const formData = new FormData();
      formData.append('name', Name);
      formData.append('role', selectedRole);
  
      if (selectedRole === 'Customer') {
        // Check if either minutes or seconds are filled
        if (!selectedDuration.minutes && !selectedDuration.seconds) {
          alert('Please enter either minutes or seconds.');
          return;
        }
        // Convert empty fields to 0
        const minutes = selectedDuration.minutes || 0;
        const seconds = selectedDuration.seconds || 0;
        const duration = formatDuration(minutes, seconds);
        formData.append('duration', duration);
      }
  
      if (selectedFile) {
        formData.append('file', selectedFile);
      } else if (!editingProfile) {
        alert('Please select an image file.');
        return;
      }
  
      const url = editingProfile ? 'http://localhost:5000/edit' : 'http://localhost:5000/add';
  
      if (editingProfile) {
        formData.append('originalName', editingProfile.name);
        formData.append('originalRole', editingProfile.type);
      }
  
      try {
        await axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
          },
        });
        alert(editingProfile ? 'Profile edited successfully.' : 'Profile added successfully.');
        handleClose();
      } catch (error) {
        console.error('Error uploading profile:', error);
      }
    } else {
      alert('Please complete all fields and select a file if needed.');
    }
  };
  
  
  
  

  const handleDeleteProfile = async (name, role) => {
    try {
      await axios.post('http://localhost:5000/delete', { name, role });
      alert('Profile deleted successfully.');
      // Refresh profile lists after deleting
      /*
      if (role === 'Relationship Manager') {
        setRMNameList(await getProfiles('Relationship Manager'));
      } else if (role === 'Sales Manager') {
        setSMNameList(await getProfiles('Sales Manager'));
      } else if (role === 'Customer') {
        setCustNameList(await getProfiles('Customer'));
      }
      */
     handleDeleteClose();
    } catch (error) {
      console.error('Error deleting profile:', error);
    }
  };
  const handleDeleteClick = (profile) => {
    setEditingProfile(profile);
    setName(profile.name);
    setSelectedRole(profile.type);
    setCurrentProfileImage(profile.image); // Set current profile image for editing
    setShowDelete(true);
  };
  const handleDeleteClose = () => {
    setShowDelete(false);
    setSelectedRole('');
    setSelectedFile(null);
    setName('');
    setEditingProfile(null);
    setCurrentProfileImage(null);
  };
  const handleEditClick = (profile) => {
    setEditingProfile(profile);
    setName(profile.name);
    setSelectedRole(profile.type);
    setCurrentProfileImage(profile.image);
  
    if (profile.type === 'Customer') {
      setSelectedDuration({ minutes: profile.minutes, seconds: profile.seconds });
    }
  
    setShow(true);
  };
  
  /*
  const getProfiles = async (role) => {
    try {
      const response = await axios.get(`http://localhost:5000/profiles?role=${role}`);
      return response.data.profiles;
    } catch (error) {
      console.error('Error fetching profiles:', error);
      return [];
    }
  };
  */
  const handleFileDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedFile(file);
    } else {
      alert('Please select an image file.');
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    // Optionally, add visual feedback here to indicate the drop zone's active state
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    // Optionally, remove visual feedback here when the dragged files leave the drop zone
  };
  const parseDuration = (duration) => {
    const parts = duration.match(/(\d+)\s*min\s*(\d+)\s*s/);
    return parts ? { minutes: parts[1], seconds: parts[2] } : { minutes: '', seconds: '' };
  };
  
  const formatDuration = (minutes, seconds) => {
    return `${minutes} min ${seconds} s`;
  };
  const handleChangeTranscript = (val) => {
    setTranscript(val)
    localStorage.setItem('transcript', val);
  }
  return (
    <div className='page'>
      <Row className='bubblecontainer'>
        <Col className='bubbles'>
          <Col className="bubbletitle">Demo Setup</Col>
          <Col>
            <div className='droptitle'>Relationship Manager</div>
            <Col>
              <Dropdown className="menus">
                <Dropdown.Toggle>
                  {rmImage && <img src={process.env.PUBLIC_URL + rmImage} alt={selectedRM} className="dropdown-toggle-image" />}
                  <div className='dropdownnames'>{selectedRM}</div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {rmNameList.map((item, index) => (
                    <Dropdown.Item key={index} onClick={() => setSelectedRM(item.name)}>
                      <img src={process.env.PUBLIC_URL + item.image} alt={item.name} className="dropdown-image" />
                      <div className='dropdownnames'>{item.name}</div>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Col>
          <Col>
            <div className='droptitle'>Sales Manager</div>
            <Col>
              <Dropdown className="menus">
                <Dropdown.Toggle>
                  {smImage && <img src={process.env.PUBLIC_URL + smImage} alt={selectedSM} className="dropdown-toggle-image" />}
                  <div className='dropdownnames'>{selectedSM}</div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {smNameList.map((item, index) => (
                    <Dropdown.Item key={index} onClick={() => {setSelectedSM(item.name); window.location.reload();}}>
                      <img src={process.env.PUBLIC_URL + item.image} alt={item.name} className="dropdown-image" />
                      <div className='dropdownnames'>{item.name}</div>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Col>
          <Row>
            <Col>
              <div className='droptitle'>Customer</div>
              <Col>
                <Dropdown className="menus">
                  <Dropdown.Toggle>
                    {custImage && <img src={process.env.PUBLIC_URL + custImage} alt={selectedCust} className="dropdown-toggle-image" />}
                    <div className='dropdownnames'>{selectedCust}</div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {custNameList.map((item, index) => (
                      <Dropdown.Item key={index} onClick={() => {setSelectedCust(item.name); setLocalDuration(item.duration)}}>
                        <img src={process.env.PUBLIC_URL + item.image} alt={item.name} className="dropdown-image" />
                        <div className='dropdownnames'>{item.name}</div>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Col>
          </Row>
          <Row>
            <Col className="bubbletitle">Transcript</Col>
            <li className='transcriptRadio'><label><input
                type="radio" name="changeTranscript"
                value="singlish" checked={transcript !== 'mixed'}
                onChange={() => handleChangeTranscript('singlish')}
              />Singlish
              </label>
          </li>
          <li className='transcriptRadio'><label><input
                  type="radio" name="changeTranscript" checked={transcript === 'mixed'}
                  onChange={() => handleChangeTranscript('mixed')}
              />Bahasa and Mandarin
              </label>
          </li>
          </Row>
        </Col>
        <Col className='bubbles'>
          <Row className='titlewithbutton'>
            <Col className="bubbletitle">Name List</Col>
            <Col className='addnewbutton'><Button className='btn' onClick={handleShow}>Add New</Button></Col>
          </Row>
          <Col className='namelist'>
            <ul>
              {[...rmNameList, ...smNameList, ...custNameList].map((item, index) => (
                <li key={index}>
                  <Col className='namelistinfo'>
                    <Col>
                      <img src={process.env.PUBLIC_URL + item.image} alt={item.name} />
                    </Col>
                    <Col className='listinfo'>
                      <div>{item.name}</div>
                      <div className='namelistposition'>{item.type}</div>
                    </Col>
                  </Col>
                  <Col className='namelistbutt'>
                    <Button onClick={() => handleEditClick(item)}><img src={editicon} alt="Edit"/></Button>
                    <Button onClick={() => handleDeleteClick(item)}><img src={deleteicon} alt="Delete"/></Button>
                  </Col>
                </li>
              ))}
            </ul>
          </Col>
        </Col>
      </Row>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{editingProfile ? 'Edit Profile' : 'Add New'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className='modalcontainer'>
              <Col className='col-5'>
                <Form.Group className="addimage" controlId="exampleForm.ControlInput1">
                  <Form.Label>Image</Form.Label>
                  <Col 
                    onClick={handleUploadClick} 
                    onDrop={handleFileDrop} 
                    onDragOver={handleDragOver} 
                    onDragEnter={handleDragEnter} 
                    onDragLeave={handleDragLeave}
                  >
                    {selectedFile ? (
                      <img src={URL.createObjectURL(selectedFile)} alt='selectedImage' className="selected-image" />
                    ) : currentProfileImage ? (
                      <img src={process.env.PUBLIC_URL + currentProfileImage} alt='currentProfileImage' className="selected-image" />
                    ) : (
                      <React.Fragment>
                        <img className='uploadedimg' src={newimageicon} alt='newimage' />
                        <div>Drag and drop or choose image file to upload</div>
                      </React.Fragment>
                    )}
                  </Col>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </Form.Group>
              </Col>
              <Col className='col-7'>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Name"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    autoFocus
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlSelect1">
                  <Form.Label>Role</Form.Label>
                  <Dropdown onSelect={handleSelect} className='roledropdown form-control'>
                    <Dropdown.Toggle>
                      {selectedRole || 'Select Role'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item eventKey="Relationship Manager">Relationship Manager</Dropdown.Item>
                      <Dropdown.Item eventKey="Sales Manager">Sales Manager</Dropdown.Item>
                      <Dropdown.Item eventKey="Customer">Customer</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                {selectedRole === 'Customer' && (
                  <div className="duration">
                    <Form.Label>Set Duration</Form.Label>
                    <Row>
                      <Col>
                        <Form.Control
                          type="number"
                          placeholder="Minutes"
                          value={selectedDuration.minutes}
                          onChange={(e) => setSelectedDuration({ ...selectedDuration, minutes: e.target.value })}
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          type="number"
                          placeholder="Seconds"
                          value={selectedDuration.seconds}
                          onChange={(e) => setSelectedDuration({ ...selectedDuration, seconds: e.target.value })}
                        />
                      </Col>
                    </Row>
                  </div>
                )}

              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="saveBtn" onClick={handleFormSubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDelete} onHide={handleDeleteClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Profile</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you would like to delete this profile?</p>
            <Col className='namelistinfo'>
                <Col>
                  <img src={currentProfileImage} alt={Name} />
                </Col>
                <Col className='listinfo'>
                  <div>{Name}</div>
                  <div className='namelistposition'>{selectedRole}</div>
                </Col>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button className="deleteBtn" onClick={() => handleDeleteProfile(Name, selectedRole)}><img src={deleteicon} alt="Delete"/></Button>
          </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Settings;
